<div class="search-block">
<div class="container">
<div>
<div id="home_nav" class="row">
  <div class="col-md-6 col-7 col-lg-6 breadcrumb-header">
    <ol class="breadcrumb ">
      <li class="breadcrumb-item" style="align-items: center;float:right;">
        <a class="bd-crumb-inactive" style="cursor: pointer;" (click)="handleNavigation('home')">Home</a>
      </li>
      <li class="breadcrumb-item">
        <a class="bd-crumb-inactive" style="cursor: pointer;" (click)="handleNavigation('browse')">Help Articles</a>
      </li>
      <li class="breadcrumb-item">
        <a class="bd-crumb-inactive" *ngIf=this.parent style="cursor: pointer;" (click)="navigate(this.childPk)">{{child}}</a>
      <li class="breadcrumb-item">
        <a class="bd-crumb-inactive" *ngIf=this.parent style="cursor: pointer;" (click)="navigateToSearch(this.pk)">{{parent}}</a>
      </li>
      <li class="breadcrumb-item active" *ngIf=this.name>{{name}}</li>
    </ol>
  </div>
  <div class="input-group col-md-5 col-5 col-lg-5 searchContainer">
    <ng-autocomplete class="form-control py-2 searchBox" [data]="data" [searchKeyword]="keyword"
      [(ngModel)]="searchKey" (selected)='selectEvent($event)' (inputChanged)='onChangeSearch($event)'
      (inputFocused)='onFocused($event)' [itemTemplate]="itemTemplate" [notFoundTemplate]="notFoundTemplate"
      (keydown.enter)="onKeyEnterSearch($event,searchKey)" (inputCleared)="searchCleared()" aria-label="Type here to Search an Article"
      placeholder="{{searchTextboxNote}}" title="{{searchTextboxHover}}">
    </ng-autocomplete>
    <ng-template #itemTemplate let-item>
      <a [innerHTML]="item.name"></a>
    </ng-template>
    <ng-template #notFoundTemplate let-notFound>
      No Suggestion...
    </ng-template>
    <span class="input-group-append" (click)="search(searchKey)">
      <button class="btn btn btn-primary searchBtn" type="button" title="{{searchButtonHover}}" aria-label="Click here to Search an Article">
        <i class="fa fa-search"></i>
      </button>
    </span>
  </div>
</div>
<div data-auto-dismiss="10000"  *ngIf="alert==true && delayed==false"
  class="alert alert-success alert-dismissible fade show" style="position: absolute; right: 20px; z-index: 999;margin-top: 10px;padding: 0.75rem 1rem;" data-auto-dismiss role="alert">
    <p>Case saved successfully, case number is {{caseAlertMessage}}</p>
</div>
</div>
</div>
</div>
<div class="container">
<h2 class="help" >{{name}}</h2>
</div>

<div class="container p-20 article-bgrnd">
  
<div *ngIf = "topics?.return_body.length > 0"  status="false">
  <div *ngFor="let topic of topics?.return_body">
    <div *ngIf="topic.pk==this.searchPk">
  <div class="col-lg-8" >
    <h4 class="aricles-header" class="topic" *ngIf="topic.kbData.count">{{topic.kbData.count}} articles found for "{{topic.stepName}}"</h4>
    <hr>
    <ul style="list-style-type: none;margin: 0px -35px;" *ngFor="let kb of topic.kbData.items">
      <li class="line" >
        <a [routerLink]="['../article']" [queryParams]="{articleId: kb.id,pk:this.pk,childPk:this.childPk,articleTag:topic.articleTag}">
          <h4 class="article-topic" [innerHTML]="kb.name"></h4>
        </a>
        <p [innerHTML]=kb.frag_data ></p>
      </li>
    </ul>
  </div>
  </div>
</div>
</div>
<div *ngIf="this.status.count!=0">
  <div class = "card-container" >
    <div class= "card-body" *ngIf=this.parent id="shp-articles-body"> 
      <div class="card-header" *ngIf = "topics?.return_body.length > 0"  status="false" id="shp-articles-header">
        <strong>Related articles</strong>
      </div>
      <div class="card-body" id="shp-articles-content">
        <ul style="list-style-type: none;padding-left: 20px;">
        <div  *ngFor="let kbView of kb">
          <a [routerLink]="['../article']" [queryParams]="{articleId: kbView.id,pk:this.pk,childPk:this.parent,article:articleTag}">
          <li>
              <h6 class="article-topic" [innerHTML]="kbView.name"></h6>
          </li>
        </a>
      </div>
        </ul>
    </div>
  </div>
</div>
  <div *ngIf="this.status.count==0">
  <div class="empty-record">No results found. Please modify your search criteria.</div>
  <div class="col-sm-4 col-md-12 col-lg-12 col-xl-4 contact">
    <div class="contact-link">
      <div class="card" style="width: 100%;">
        <div class="card-header" *ngIf="topArticles.total > 0">
          <strong>{{topArticleTitle}}</strong>
        </div>
        <div class="card-body" *ngIf="topArticles.total > 0">

          <ul style="list-style-type:none;padding-left: 20px;">
            <div *ngFor="let article of topArticles.items">
              <a [routerLink]="['../article']" [queryParams]="{articleId: article.article_id}">
              <li class="toparticles-block">{{article.article_title}}</li>
            </a>
            </div>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
</div>